import React from 'react';
import {
  Paper,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  LightbulbOutlined as TipIcon,
  HelpOutline as HelpIcon,
} from '@mui/icons-material';
import { useTranslations } from 'next-intl';

interface Step {
  label: string;
  content: (t: (key: string) => string) => React.ReactNode;
}

interface Tip {
  title: string;
  description: string;
}

interface UserManualProps {
  steps: Step[];
  tips?: Tip[];
}

const UserManual: React.FC<UserManualProps> = ({ steps, tips }) => {
  const tManual = useTranslations('manual');

  return (
    <Paper sx={{ mt: 3, p: 2 }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="user-manual-content"
          id="user-manual-header"
        >
          <Typography variant="h6" sx={{ display: 'flex', alignItems: 'center' }}>
            <HelpIcon sx={{ mr: 1 }} />
            {tManual('how_to_use')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <List>
            {steps.map((step, index) => (
              <ListItem key={index}>
                <ListItemText
                  primary={step.label}
                  secondary={step.content(tManual)}
                />
              </ListItem>
            ))}
          </List>
          
          {tips && tips.length > 0 && (
            <>
              <Typography variant="h6" sx={{ mt: 2, mb: 1, display: 'flex', alignItems: 'center' }}>
                <TipIcon sx={{ mr: 1 }} />
                {tManual('tips')}
              </Typography>
              <List>
                {tips.map((tip, index) => (
                  <ListItem key={index}>
                    <ListItemIcon>
                      <TipIcon color="primary" />
                    </ListItemIcon>
                    <ListItemText
                      primary={tip.title}
                      secondary={tip.description}
                    />
                  </ListItem>
                ))}
              </List>
            </>
          )}
        </AccordionDetails>
      </Accordion>
    </Paper>
  );
};

export default UserManual; 